/**
 * Catch-all route (`*`) — renders the shared "not found or expired" page
 * (spec.md § Routing & pages). Also the target the pad route navigates to after
 * a successful delete.
 */

import { NotFound } from "../components/NotFound";

export default function NotFoundRoute(): React.JSX.Element {
  return <NotFound />;
}
